// test1674
(1674 && 0);
